import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const Container = styled('div')`
min-height: 100vh;
`

export const SecondRowContainer = styled(Box)({
    maxWidth: '80vw', // Default width for desktop

    // Center the container on desktop
    margin: '0 auto',
  
    // Media query for screens with a maximum width of 600px (adjust as needed)
    '@media (max-width: 900px)': {
      maxWidth: '100%', // Set width to 100% for smaller screens
    },
  });

export const ModalContent = styled('div')`
  background-color: #fff;
  max-height: 70vh;
  overflow-y: auto;  // Enable vertical scrolling when content;
  width: 30%; // Full screen on mobile devices
  margin: 0 auto; /* Center horizontally */
  justify-content: center; /* Center horizontally */
  margin-top: 10vh;
  padding: 20px 20px 30px;
  margin-bottom: 15vh;
  
  @media (max-width: 768px) {
      width: 90%; // Full screen on mobile devices
      height: 80vh;
      margin: 10vh auto; /* Center horizontally */
  }
`

export const OverviewLeft = styled('div')`
  @media (max-width: 768px) {    
    margin: 0 5vw; /* Center horizontally */
  }
 
`
export const OverviewRight = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 10px;
  align-items: initial !important;
  @media (max-width: 768px) {    
    margin: 0 5vw; /* Center horizontally */
  }
`;
export const OverviewTitle = styled('div')`
  font-size: 1.2rem;
  font-weight: 600;
  color: #000;
  margin-bottom: 15px;
  margin-top: 25px;
`

export const OfferContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: top;
  align-items: top;
  background-color: #fff;
  margin-bottom: 20px;
`

export const LocationContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: top;
  align-items: top;
  background-color: #fff;
  margin-bottom: 20px;
`
export const OpeningTimesContainer = styled('div')`
  margin-top: 10px;
  margin-bottom: 20px;
  font-size: 0.8rem;
`